<template>
  <svg slot="icon" class="icon" aria-hidden="true">
    <use :xlink:href="`#el-icon-${name}`" />
  </svg>
</template>

<script>
export default {
  name: 'BSvg',
  props: {
    name: {
      type: String,
      require: true,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/BSvg/index.vue